import {
  CREATE_LIST_PRODUCT_INVOICE,
  CREATE_LIST_PRODUCT_INVOICE_FAIL,
  CREATE_LIST_PRODUCT_INVOICE_SUCCESS,
  CREATE_PRODUCT_INVOICE,
  CREATE_PRODUCT_INVOICE_FAIL,
  CREATE_PRODUCT_INVOICE_SUCCESS,
  DELETE_PRODUCT_INVOICE,
  DELETE_PRODUCT_INVOICE_FAIL,
  DELETE_PRODUCT_INVOICE_SUCCESS,
  EDIT_PRODUCT_INVOICE,
  EDIT_PRODUCT_INVOICE_FAIL,
  EDIT_PRODUCT_INVOICE_SUCCESS,
  GET_ALL_PRODUCT_INVOICE,
  GET_ALL_PRODUCT_INVOICE_FAIL,
  GET_ALL_PRODUCT_INVOICE_SUCCESS,
  GET_DETAIL_PRODUCT_INVOICE,
  GET_DETAIL_PRODUCT_INVOICE_FAIL,
  GET_DETAIL_PRODUCT_INVOICE_SUCCESS,
  GET_LIST_PRODUCT_INVOICE,
  GET_LIST_PRODUCT_INVOICE_FAIL,
  GET_LIST_PRODUCT_INVOICE_SUCCESS,
  GET_LIST_VAT,
  GET_LIST_VAT_FAIL,
  GET_LIST_VAT_SUCCESS,
  RESET_CREATE_LIST_PRODUCT_INVOICE,
  RESET_CREATE_PRODUCT_INVOICE,
  RESET_DELETE_PRODUCT_INVOICE,
  RESET_EDIT_PRODUCT_INVOICE,
  RESET_LIST_PRODUCT_INVOICE,
  SET_COLUMN_VISIBLE_PRODUCT_INVOICE,
} from "./actionTypes";

const INIT_STATE = {
  type: null,
  // sản phẩm/ dịch vụ
  product: {
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-checker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
    loading: false,
    listData: [],
    totalCount: 0,
    columnsVisible: {},
  },
  detailProduct: {
    loading: false,
    data: null,
    error: null,
  },
  createProduct: {
    loading: false,
    data: null,
    error: null,
  },
  createListProduct: {
    loading: false,
    data: null,
    error: null,
  },
  editProduct: {
    loading: false,
    data: null,
    error: null,
  },
  deleteProduct: {
    loading: false,
    data: null,
    error: null,
  },
  listVat: [],
  listAllProduct: [],
};

const productInvoice = (state = INIT_STATE, action) => {
  const curProduct = state.product;
  switch (action.type) {
    // sản phẩm/ dịch vụ
    case GET_LIST_PRODUCT_INVOICE:
      return {
        ...state,
        product: {
          ...curProduct,
          loading: true,
          //   params: action.params,
        },
      };
    case GET_LIST_PRODUCT_INVOICE_SUCCESS:
      return {
        ...state,
        product: {
          ...curProduct,
          loading: false,
          listData: action.listData,
          totalCount: action.totalCount,
        },
      };

    case GET_LIST_PRODUCT_INVOICE_FAIL:
      return {
        ...state,
        product: {
          ...curProduct,
          loading: false,
          listData: [],
          totalCount: 0,
        },
        error: action.error,
      };
    case RESET_LIST_PRODUCT_INVOICE:
      return {
        ...state,
        product: {
          ...curProduct,
          loading: false,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-checker_date",
            columnFilter: {},
            keywords: "",
          },
          listData: [],
          totalCount: 0,
        },
        type: action.type,
      };
    // Detail sản phẩm/ dịch vụ
    case GET_DETAIL_PRODUCT_INVOICE:
      return {
        ...state,
        detailProduct: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_DETAIL_PRODUCT_INVOICE_SUCCESS:
      return {
        ...state,
        detailProduct: {
          loading: false,
          data: action.data,
          error: null,
        },
      };

    case GET_DETAIL_PRODUCT_INVOICE_FAIL:
      return {
        ...state,
        detailProduct: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    // Tạo sản phẩm dịch vụ
    case CREATE_PRODUCT_INVOICE:
      return {
        ...state,
        createProduct: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_PRODUCT_INVOICE_SUCCESS:
      return {
        ...state,
        createProduct: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_PRODUCT_INVOICE_FAIL:
      return {
        ...state,
        createProduct: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_PRODUCT_INVOICE:
      return {
        ...state,
        createProduct: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Tạo list sản phẩm dịch vụ
    case CREATE_LIST_PRODUCT_INVOICE:
      return {
        ...state,
        createListProduct: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case CREATE_LIST_PRODUCT_INVOICE_SUCCESS:
      return {
        ...state,
        createListProduct: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case CREATE_LIST_PRODUCT_INVOICE_FAIL:
      return {
        ...state,
        createListProduct: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_CREATE_LIST_PRODUCT_INVOICE:
      return {
        ...state,
        createListProduct: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Cập nhật sản phẩm dịch vụ
    case EDIT_PRODUCT_INVOICE:
      return {
        ...state,
        editProduct: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case EDIT_PRODUCT_INVOICE_SUCCESS:
      return {
        ...state,
        editProduct: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case EDIT_PRODUCT_INVOICE_FAIL:
      return {
        ...state,
        editProduct: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_EDIT_PRODUCT_INVOICE:
      return {
        ...state,
        editProduct: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Xóa sản phẩm dịch vụ
    case DELETE_PRODUCT_INVOICE:
      return {
        ...state,
        deleteProduct: {
          loading: true,
          data: null,
          error: null,
        },
      };
    case DELETE_PRODUCT_INVOICE_SUCCESS:
      return {
        ...state,
        deleteProduct: {
          loading: false,
          data: action.data,
          error: null,
        },
        type: action.type,
      };

    case DELETE_PRODUCT_INVOICE_FAIL:
      return {
        ...state,
        deleteProduct: {
          loading: false,
          data: null,
          error: action.error,
        },
        type: action.type,
      };
    case RESET_DELETE_PRODUCT_INVOICE:
      return {
        ...state,
        deleteProduct: {
          loading: false,
          data: null,
          error: null,
        },
        type: action.type,
      };
    // Get list Vat
    case GET_LIST_VAT:
      return {
        ...state,
        listVat: [],
      };
    case GET_LIST_VAT_SUCCESS:
      return {
        ...state,
        listVat: action.data,
      };

    case GET_LIST_VAT_FAIL:
      return {
        ...state,
        listVat: [],
      };
    // GET_ALL_PRODUCT_INVOICE
    case GET_ALL_PRODUCT_INVOICE:
      return {
        ...state,
        listAllProduct: [],
      };
    case GET_ALL_PRODUCT_INVOICE_SUCCESS:
      return {
        ...state,
        listAllProduct: action.data,
      };

    case GET_ALL_PRODUCT_INVOICE_FAIL:
      return {
        ...state,
        listAllProduct: [],
      };
    // Set column
    case SET_COLUMN_VISIBLE_PRODUCT_INVOICE:
      curProduct.columnsVisible[action.field] = action.value;
      return {
        ...state,
        product: {
          ...curProduct,
        },
      };
    default:
      return state;
  }
};

export default productInvoice;
